import type { DealFormData } from '@openx/types/deal';
import { ThirdPartyFeeConfigRevenueMethod } from '@openx/types/gqlTypes';
import { type Path, useWatch } from 'react-hook-form';

export const useIsCpmRevenue = (index: number) => {
  const revenueMethodFieldName: Path<DealFormData> = `third_party_fees_config.${index}.revenue_method`;

  const observableRevenueMethod = useWatch<DealFormData, typeof revenueMethodFieldName>({
    name: revenueMethodFieldName,
  });

  return observableRevenueMethod === ThirdPartyFeeConfigRevenueMethod.Cpm;
};
